import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/index.js";
import App from "./App.vue";
import Products from "./components/Products.vue";
import Cart from "./components/Cart.vue";
import Pedidos from "./components/Pedidos.vue";
import Perguntas from "./components/Perguntas.vue";
import PerguntasPizza from "./components/PerguntasPizza.vue";
import ProdutoUnico from "./components/ProdutoUnico.vue";
import Sobre from "./components/Sobre.vue";
import Loja from "./components/Loja.vue"
import "semantic-ui-css/semantic.css";
import VueAnalytics from "vue-analytics";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faUserSecret);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueRouter);

/* /DeliveryCenter/3/cardapio */
// Define routes
const routes = [
  { path: "/pizzas", component: PerguntasPizza },
  { path: "/pedidos", component: Pedidos },
  { path: "/sobre", component: Sobre },
  { path: "/", component: Products },
  { path: "/lojas", component: Loja },
  { path: "/perguntas", component: Perguntas },
  { path: "/produtounico", component: ProdutoUnico },
  { path: "/cart", component: Cart },
];
Vue.use(VueAnalytics, {
  id: "G-VV9X7DS4ST",
  router,
});

// Register routes
const router = new VueRouter({
  mode: "hash",
  routes,
});

new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
});
